import { UseDisclosureReturn } from '@heroui/use-disclosure';
import { Modal, ModalBody, ModalContent } from '@heroui/modal';

import { useAddSongMedia } from '@/hooks/useSongbook.ts';
import { Song } from '@/core/db.ts';

import SongFileDrop from './SongFileDrop.tsx';

interface SongMediaModalProps {
  song: Song;
  disclosure: UseDisclosureReturn;
}

function SongMediaModal({ disclosure, song }: SongMediaModalProps) {
  const { isPending: isAddSongPending, mutateAsync: addSongMedia } = useAddSongMedia(song.id);

  return (
    <Modal
      backdrop="blur"
      isDismissable={!isAddSongPending}
      isOpen={disclosure.isOpen}
      size="3xl"
      onOpenChange={disclosure.onOpenChange}
    >
      <ModalContent className="bg-default-50 text-foreground w-full">
        <ModalBody className="p-8">
          <SongFileDrop
            pending={isAddSongPending}
            supports="media"
            onFileAdd={async (type, contents) => {
              await addSongMedia({ type, contents });
              disclosure.onClose();
            }}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default SongMediaModal;
